import {format} from 'date-fns'
import {ru} from 'date-fns/locale'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {cn} from '@containers/html-utils'
import {Shift, useCalendarStore} from '../../calendar-store'
import IconLeft from './icon-left.svg'
import IconRight from './icon-right.svg'

const HeaderTw = tw.div`
  flex
  px-8
  justify-between
  h-24
  bg-main-even-old
`

const IconTw = tw.div`
  w-24
  cursor-pointer
  text-action-default
`

const TodayTw = tw.div`
  self-center
  leading-4
  cursor-pointer
  text-11
  text-action-default
  px-8
`

const DateTw = tw.div`
  self-center
  leading-4
  min-w-96
  text-main-old
  text-12
  font-semibold
  capitalize
`

const dayFormat = 'd'
const monthFormat = 'LLLL'

interface Props {
  shift: Shift
}

export const Header = observer(({shift}: Props) => {
  const [state, store] = useCalendarStore()
  const language = Lang.getLang()

  return (
    <HeaderTw>
      <div className={cn('flex', shift !== 'current' && 'pointer-events-none')}>
        <DateTw>
          {format(state.currentDate[shift], monthFormat, {
            locale: language === 'ru' && ru
          })}{' '}
          {format(store.startDate(shift), dayFormat)}
          {'—'}
          {format(store.endDate(shift), dayFormat)}
        </DateTw>
        <div className="flex mr-8">
          <IconTw onClick={() => store.changeWeekHandle('prev')}>
            <IconLeft />
          </IconTw>
          <div className="w-8"></div>
          <IconTw onClick={() => store.changeWeekHandle('next')}>
            <IconRight />
          </IconTw>
        </div>
        <TodayTw onClick={() => store.changeWeekHandle('current')}>
          {Lang.msg.calendar.current}
        </TodayTw>
      </div>
      <div className="self-center leading-4 text-third-old text-11">
        {Lang.msg.calendar.weekNumber}
        {state.weekNumber[shift]}
      </div>
    </HeaderTw>
  )
})
